<template>
  <div class="wapper">
    <el-container style="100%">
      <DocumentType @getDocumentTypeId="getDocumentTypeId"></DocumentType>
      <el-main style="background: #fff; margin-left: 10px">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline"
            >
              <div class="uers-right">
              </div>
              <div class="uers-left">
                <el-form-item>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.name"
                      placeholder="姓名"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.phone"
                      placeholder="手机"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.company"
                      placeholder="公司"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.groupNo"
                      placeholder="团组"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.code"
                      placeholder="码值"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.idNumber"
                      placeholder="编号"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.rfid"
                      placeholder="rfid"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.remark"
                      placeholder="备注"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.label"
                      placeholder="标签"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-date-picker
                      style="width: 185px"
                      v-model="searchForm.startDate"
                      type="datetime"
                      placeholder="开始日期"
                  ></el-date-picker>
                  <el-date-picker
                      style="width: 185px"
                      v-model="searchForm.endDate"
                      type="datetime"
                      placeholder="结束日期"
                  ></el-date-picker>
                  <el-select v-model="searchForm.isPrint">
                    <el-option value="-1" label="全部打印"></el-option>
                    <el-option value="0" label="未打印"></el-option>
                    <el-option value="1" label="打印1次"></el-option>
                    <el-option value="2" label="打印2次"></el-option>
                    <el-option value="3" label="打印3次"></el-option>
                    <el-option value="4" label="打印4次"></el-option>
                    <el-option value="5" label="打印5次"></el-option>
                    <el-option value="6" label="打印6次"></el-option>
                    <el-option value="7" label="打印7次"></el-option>
                    <el-option value="8" label="打印8次"></el-option>
                    <el-option value="9" label="打印9次"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.isMake">
                    <el-option value="-1" label="全部入库"></el-option>
                    <el-option value="0" label="未入库"></el-option>
                    <el-option value="1" label="已入库"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.isRepeat">
                    <el-option value="0" label="全部数据"></el-option>
                    <el-option value="1" label="姓名重复"></el-option>
                    <el-option value="2" label="手机号重复"></el-option>
                    <el-option value="3" label="身份证重复"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.isRfid">
                    <el-option value="-1" label="全部卡"></el-option>
                    <el-option value="0" label="未写卡"></el-option>
                    <el-option value="1" label="已写卡"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="searchForm.isAvatar">
                    <el-option value="-1" label="全部头像"></el-option>
                    <el-option value="0" label="没有头像"></el-option>
                    <el-option value="1" label="已有头像"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.zd">
                    <el-option value="-" label="全部重点状态"></el-option>
                    <el-option value="" label="未验证"></el-option>
                    <el-option value="0" label="成功"></el-option>
                    <el-option value="-1" label="失败"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.status">
                    <el-option value="-" label="全部三要素状态"></el-option>
                    <el-option value="" label="未验证"></el-option>
                    <el-option value="0" label="成功"></el-option>
                    <el-option value="-1" label="失败"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.status2">
                    <el-option value="-" label="全部二要素状态"></el-option>
                    <el-option value="" label="未验证"></el-option>
                    <el-option value="0" label="成功"></el-option>
                    <el-option value="-1" label="失败"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.disabled">
                    <el-option value="-1" label="全部公安审核"></el-option>
                    <el-option value="0" label="公安未审核"></el-option>
                    <el-option value="1" label="公安已审核"></el-option>
                    <el-option value="2" label="审核不通过"></el-option>
                    <el-option value="3" label="无效身份证"></el-option>
                  </el-select>&nbsp;&nbsp;
                  <el-button
                      type="primary"
                      icon="el-icon-search"
                      @click="searchSubmit"
                  >搜索
                  </el-button
                  >
                  <el-button
                      type="primary"
                      icon="el-icon-export"
                      @click="exportExcel()"
                  >导出
                  </el-button
                  >
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
            >
              <!--                @selection-change="handleSelectionChange"-->
              <!--              <el-table-column-->
              <!--                  type="selection"-->
              <!--                  width="40"-->
              <!--                  align="center"-->
              <!--              ></el-table-column>-->
              <el-table-column
                  prop="idCard"
                  width="150"
                  label="身份证/rfid"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.idCard }}</p>
                  <p>{{ scope.row.rfid }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="avatar"
                  width="60"
                  label="头像"
                  align="center"
              >
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.avatar"
                        :preview-src-list="[scope.row.avatar]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  width="100"
                  label="姓名/手机号"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.phone }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="company"
                  label="公司/团组/职位"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.company }}</p>
                  <p>{{ scope.row.groupNo }}</p>
                  <p>{{ scope.row.position }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="typeName"
                  width="90"
                  label="证件类型"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.typeName }}</p>
                  <p>{{
                      scope.row.disabled == 0 ? "公安未审核" :
                          scope.row.disabled == 1 ? "公安已审核" :
                              scope.row.disabled == 2 ? "公安审核失败" : "无效身份证"
                    }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="code"
                  width="270"
                  label="码值/编号"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.code }}</p>
                  <p>{{ scope.row.idNumber }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  width="80"
                  prop="isPrint"
                  label="状态"
                  align="center"
              >
                <template slot-scope="scope">
                  <p v-if="!gb">三要素:{{
                      scope.row.status ? scope.row.status : "无"
                    }}</p>
                  <p v-if="!gb">二要素:{{ scope.row.status2 ? scope.row.status2 : "无" }}</p>
                  <p v-if="!gb">zd:{{ scope.row.zd ? scope.row.zd : "无" }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="effectiveStart"
                  label="有效时间"
                  align="center"
                  width="150"
                  v-if="gb"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.effectiveStart }}</p>
                  <p>{{ scope.row.effectiveEnd }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  width="200"
                  prop="printDate"
                  label="创建/打印/入库时间"
                  align="left"
              >
                <template slot-scope="scope">
                  <p>已创建：{{ scope.row.createDate }}</p>
                  <p>{{ "打印" + scope.row.print + "次" }}：{{ scope.row.printDate }}</p>
                  <p>{{ scope.row.isMake ? "已入库" : "未入库" }}：{{ scope.row.makeDate }}</p>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button>
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditPapersManage
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditPapersManage>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import {Loading} from "element-ui";
import EditPapersManage from "../../../components/ticketing/certificate/EditPapersManage";
import DocumentType from "../../../components/ticketing/certificate/docuType/DocumentType";
import DeleteDialog from "../../../components/public/DeleteConfim";

export default {
  data() {
    return {
      fileList: [],
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      //表格高度适配
      tabheight: "",
      roles: localStorage.getItem("roles"),
      gb: window.location.hostname.indexOf("gb") > -1,
      searchForm: {
        label: "",
        status: "-",
        status2: "-",
        zd: "-",
        groupNo: "",
        name: "",
        code: "",
        phone: "",
        idNumber: "",
        documentTypeId: 0,
        isRepeat: "0",
        isPrint: "-1",
        isRfid: "-1",
        isMake: "-1",
        disabled: "-1",
        company: "",
        rfid: "",
        isAvatar: "-1",
        remark: "",
        endDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ),
        startDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() -
            (new Date(new Date().toLocaleDateString()).getTime() -
                new Date(new Date().getFullYear().toString()))
        ),
      },
      documentTypeId: "",
      editData: {},
      listShow: true,
      delVisible: false,
      document_Id: "",
      editShow: false,
      dataList: [],
      dataType: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
      action: localStorage.getItem("url") + "/Upload/File?eId=" + localStorage.getItem("project_Id"),
      attr: [],
      ids: [],
    };
  },
  mounted() {
    if (document.documentElement.clientHeight < 900) {
      this.pagesize = 5;
    }
    this.getData();
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
  },
  methods: {
    getDocumentTypeId(val) {
      this.documentTypeId = val;
      this.searchForm.documentTypeId = val;
      this.getData();
    },
    //  文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.$message.warning("文件已移除");
    },
    handleChange(file, fileList) {
      this.fileList = this.fileList.slice(-1);
    },
    handleExceed() {
      //提示最多只能上传1个
      this.$message.warning("最多上传1个文件！");
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    exportExcel() {
      var search = {
        projectId: this.projectId,
        name: this.searchForm.name,
        code: this.searchForm.code,
        isPrint: this.searchForm.isPrint,
        isAvatar: this.searchForm.isAvatar,
        idNumber: this.searchForm.idNumber,
        company: this.searchForm.company,
        groupNo: this.searchForm.groupNo,
        rfid: this.searchForm.rfid,
        documentTypeId: this.searchForm.documentTypeId,
        pageIndex: 0,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        isRfid: this.searchForm.isRfid,
        pageSize: this.total,
        remark: this.searchForm.remark,
        phone: this.searchForm.phone,
        status: this.searchForm.status,
        status2: this.searchForm.status2,
        zd: this.searchForm.zd,
        verify: this.searchForm.verify,
        disabled: this.searchForm.disabled,
        isMake: this.searchForm.isMake,
        label: this.searchForm.label,
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
          .post(`/DocumentDelete/Export`, search)
          .then((res) => {
            loading.close();
            if (res.data.data) {
               window.open(res.data.data, '_self');
              // this.$download(res.data.data, '导出证件.xlsx');
            } else {
              this.$message.error("导出失败");
            }
          })
          .catch((a) => {
            loading.close();
            this.$message.error("导出失败");
          });
    },
    downLoad(url, fileName) {
      return fetch(url).then((res) => {
        res.fetch(url).then((blob) => {
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        });
      });
    },
    importDataDelete() {
      this.ids = JSON.parse(localStorage.getItem("ids"));
      if (this.ids && this.ids.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$axios
            .put("/DocumentDelete/BatchDelete/" + this.projectId, this.ids)
            .then((res) => {
              if (res.data.hasError == false) {
                loading.close();
                localStorage.setItem("attr", null);
                this.getData();
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
                loading.close();
              }
            })
            .catch(function () {
              loading.close();
            });
      } else {
        this.$message.error("没有可上传的数据");
      }

    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.searchSubmit();
      console.log(`每页 ${val} 条`);
    },
    handlePrinter(index, row) {
      window.open(localStorage.getItem("url") + "/printer/" + row.documentId);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchSubmit();
    },
    handleEdit(index, row) {
      this.editData = row;
      row.isPrint = true;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      this.getSearch();
      this.attr = [];
    },
    getSearch() {
      var search = {
        projectId: this.projectId,
        name: this.searchForm.name,
        code: this.searchForm.code,
        isPrint: this.searchForm.isPrint,
        isRepeat: this.searchForm.isRepeat,
        isRfid: this.searchForm.isRfid,
        isAvatar: this.searchForm.isAvatar,
        idNumber: this.searchForm.idNumber,
        company: this.searchForm.company,
        remark: this.searchForm.remark,
        groupNo: this.searchForm.groupNo,
        rfid: this.searchForm.rfid,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        documentTypeId: this.searchForm.documentTypeId,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        phone: this.searchForm.phone,
        status: this.searchForm.status,
        status2: this.searchForm.status2,
        zd: this.searchForm.zd,
        verify: this.searchForm.verify,
        disabled: this.searchForm.disabled,
        isMake: this.searchForm.isMake,
        label: this.searchForm.label,
      };
      this.$axios.post("/DocumentDelete/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    // 获取数据
    getData() {
      this.currentPage = 1;
      this.searchSubmit();
    },
    addSubmit() {
      this.document_Id = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    handleDelete(index, row) {
      this.document_Id = row.DocumentDeleteId;
      this.delVisible = true;
    },
    deleteData() {
      this.$axios.delete(`/DocumentDelete/${this.document_Id}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    handleCloseVisible() {
      this.document_Id = "";
      this.delVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    EditPapersManage,
    DocumentType,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  height: 100%;
  margin-left: 10px;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
  margin-bottom: 20px;
}

.btn-r {
  margin-right: 20px;
}

.file-up {
  width: 100px;
  position: absolute;
  height: 32px;
  opacity: 0;
}

.import-text {
  margin: 15px 0;
}

.el-upload--text {
  width: 110px;
  height: 32px;
  line-height: 32px;
  border: 0;
}

.down-template {
  position: absolute;
  top: 40px;
  right: 10px;
}

.el-dialog {
  height: auto;
}
</style>